module.exports = __webpack_public_path__ + "static/media/covi_too_cle_too.2105a709.png";